import React, { useState, useRef, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "component/UseAuth";

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    setTimeout(() => {
      navigate("/");
    }, 0);
  };

  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRef = useRef(null);
  const toggleDropdown = (menu) => {
      setOpenDropdown(openDropdown === menu ? null : menu);
  };
  useEffect(() => {
      const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setOpenDropdown(null);
      }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      };
  }, []);

  return (
    <nav
      class="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
      id="layout-navbar"
    >
      <div class="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
      <ul class="navbar-nav flex-row align-items-center ms-auto">
      <div class="flex-grow-1 text-end">
          <span class="fw-semibold d-block">{user?.name}</span>
          <small class="text-muted">{user?.jabatan}</small>
      </div>
      <li class="nav-item navbar-dropdown dropdown-user dropdown" ref={dropdownRef}>
          <a
          class="nav-link dropdown-toggle hide-arrow"
          href="#"
          onClick={(e) => {
              e.preventDefault();
              toggleDropdown("user");
          }}
          >
          <div class="avatar avatar-online">
              <img
              src="../assets/img/avatars/1.png"
              alt="User Avatar"
              class="w-px-40 h-auto rounded-circle"
              />
          </div>
          </a>
          <ul class={`dropdown-menu dropdown-menu-end ${openDropdown === "user" ? "show" : ""}`} data-bs-popper="static">
          <li>
              <a class="dropdown-item" onClick={handleLogout} style={{ cursor: "pointer" }}>
              <i class="bx bx-power-off me-2"></i>
              <span class="align-middle">Log Out</span>
              </a>
          </li>
          </ul>
      </li>
      </ul>
      </div>
    </nav>
  );
};

export default Navbar;
